"use client";

import { Toaster } from "sonner";

export function ClientToaster() {
  return <Toaster richColors position="bottom-right" />;
}